const services = [
    {
        title: "Whole-School Transformation/Development",
        desc:
            "<b>Best for</b>: 21st Century Innovation and Holistic Student Development\n" +
            "\n<b>Includes:</b>\n",
        listItems: [
            "Multi-month or year-long partnership",
            "Leadership coaching + staff development + high quality staff recruitment",
            "Integration of trauma-informed and innovative practices across all classrooms",
            "Holistic child development nurtures the spiritual, intellectual, emotional, social, and physical growth of each child, supporting them to thrive as healthy, capable, and connected individuals",
            "Student leadership and voice structures",
            "Family/community engagement",
        ]
    },
    {
        title: "Reclaimed Wisdom Curriculum",
        subtitle: "A Strategic Investment in Prevention & Well-being",
        desc:
            "<u>The Case for Investment</u>\n" +
            "\n" +
            "School systems are facing a compounding crisis: escalating costs tied to student mental health needs, classroom disruptions, chronic absenteeism, and educator burnout. Current models often rely on reactive interventions—crisis response, external referrals, and managing behavioral escalation—which are financially costly and strain already limited human and institutional resources.\n" +
            "\n" +
            "The Reclaimed Wisdom Curriculum offers a paradigm shift. It is a proactive, front-end prevention strategy designed to strengthen the foundational conditions students need in order to engage and learn. By embedding structured Wisdom Circles directly into the school schedule, we build student capacity before crises occur, addressing root causes of distress and disconnection.\n" +
            "\n" +
            "This investment moves beyond containing problems to cultivating durable assets within your school community: emotional resilience, self-regulation, authentic belonging, and collective responsibility.\n" +
            "\n" +
            "<u>How It Works: A Proactive Model</u>\n" +
            "\n" +
            "<b>1. Prevents Escalation:</b> Reduces the frequency and intensity of behavioral incidents and mental health crises by building core self-regulation and social-emotional skills.\n" +
            "\n<b>2. Boosts Engagement:</b> Fosters the safety and connection that are prerequisites for academic attention, participation, and attendance.\n" +
            "\n<b>3. Sustains Educators:</b> Provides a sustainable, co-facilitated framework that decreases teacher burnout by improving classroom climate and distributing the emotional labor of support.\n" +
            "\n<b>4. Optimizes Resources:</b> Creates a tier-one universal support that lessens the burden on overextended specialized staff and high-cost reactive services.\n" +
            "\n" +
            "<u>Rooted in Wisdom, Designed for All</u>\n" +
            "\n" +
            "The curriculum is thoughtfully informed by timeless Indigenous principles of circle practice, oral storytelling, and relational leadership—traditions that have sustained communities for generations. While deeply rooted in this wisdom, the program is adaptable and inclusive, designed to benefit all students in a multicultural world. It fosters a unifying school culture where diverse backgrounds become sources of strength, building bridges of empathy and shared responsibility.\n" +
            "\n" +
            "Investing in the Reclaimed Wisdom Curriculum is an investment in the very fabric of your school community. It builds the relational and regulatory capital that transforms school climate, improves outcomes, and creates a legacy of well-being for every student and educator.",
        bgColour: "bg-services-xlight"
    },
    {
        title: "Group Life Coaching for Adolescents (Grades 7-9) and (Grades 10-12)",
        subtitle: "12-week group coaching program for teens",
        focus: "RAPIDLY build self-worth, develop effective coping mechanisms, and master strategies to THRIVE in both academic and personal life.",
        results: [
            "OVERCOME ANXIETY and SELF-WORTH challenges",
            "Confidence-building techniques",
            "Enhance study and healthy habits"
        ],
        bgColour: "bg-services-light"
    },
    {
        title: "Educator Workshops",
        focus: "Workshops that provide educators with the tools to address STUDENT ANXIETY, foster emotional resilience, and create supportive classroom environments.",
        results: [
            "Manage ANXIETY in the classroom",
            "Build student SELF-WORTH and CONFIDENCE",
            "Implementation of WISDOM CIRCLES"
        ],
        bgColour: "bg-services-med"
    },
    {
        title: "Group Anxiety to Achievement Coaching for Parents and Guardians",
        focus: "Guidance and strategies for parents to support their child’s emotional and academic growth, ensuring they feel connected and supported at home.",
        results: [
            "Understand ANXIETY",
            "Tools for communication and empathy",
            "Create a nurturing environment for growth using CURIOSITY"
        ],
        bgColour: "bg-services-dark"
    },
    {
        title: "1-on-1 Anxiety to Achievement Coaching for students, parents, educators, and community members",
        focus: "Effective tools to RAPIDLY support OUR CHILDREN who struggle with ANXIETY, build stronger connections, and develop coping mechanisms at home and at school.",
        results: [
            "Increased Confidence: Participants gain the confidence to OVERCOME ANXIETY related challenges",
            "Long-term Coping Skills: Sustainable techniques that help OVERCOME ANXIETY beyond the coaching sessions",
            "Greater Emotional Awareness: Improved understanding of emotions, leading to better self-regulation and empathy"
        ],
        bgColour: "bg-services-xdark"
    }
];

export default services;